const tokenList = {
  state: {
    cancelTokenArr: [],
    requireList: []
  },
  mutations: {
    pushToken(state, payload) {
      state.cancelTokenArr.push(payload.cancelToken)
    },
    clearToken(state) {
      state.cancelTokenArr.forEach(item => {
        item('路由跳转取消请求')
      })
      state.cancelTokenArr = []
    },
    SET_REQUIRE: (state, require) => {
      state.requireList.push(require)
    },
    BATCH_CANCEL: (state) => {
      state.requireList.forEach(e => {
        e('取消请求')
      })
      state.requireList = []
    },
  },
  actions: {
    cancelRequest({ commit }) {
      commit('BATCH_CANCEL')
    }
  }
}

export default tokenList

// import Vue from 'vue'
// import Vuex from 'vuex'
// Vue.use(Vuex)
// export const store = new Vuex.Store({
//   state: {
//     cancelTokenArr: [] // 取消请求token数组
//   },
//   mutations: {
//     pushToken (state, payload) {
//       state.cancelTokenArr.push(payload.cancelToken)
//     },
//     clearToken (state) {
//       state.cancelTokenArr.forEach(item => {
//         item('路由跳转取消请求')
//       })
//       state.cancelTokenArr = []
//     }
//   }
// })